import { load } from "../bot-loaders"
import { shouldProcessImage, shrinkImage } from "./image-processing"

export type MediaItem = {
    id: number
    name: string
    s3Id: string
    mimetype: string
    size: number
    url: string
    created: Date
}

function fixDate(i:MediaItem):MediaItem {
    return {...i, created: new Date(i.created)}
}

export async function listMedia(){
    var list = await load("media/list")
    return list.result.map(fixDate) as MediaItem[];
}

export async function uploadMedia(file:File){
    if(shouldProcessImage(file)){
        const blob = await shrinkImage(file);
        return uploadMediaBlob(blob, file.name);
    }

    var form = new FormData();
    form.append("file", file);
    var result = await load("media/add", form);
    return fixDate(result.media);
}

export async function uploadMediaBlob(file:Blob, name:string){
    var form = new FormData();
    form.append("file", file, name);
    var result = await load("media/add", form);
    return fixDate(result.media);
}

export async function renameMedia(media:number, newName: string){
    var result = await load("media/rename", {media, newName});
    return true;
}

export async function deleteMedia(media:number){
    var result = await load("media/delete", {media});
    return true;
}

export async function loadMedia(mediaId:number):Promise<MediaItem>{
    if(!mediaId) return null;
    var result = await load("media/" + mediaId);
    return fixDate(result.media);
}

